/** Whether this page load opened the app at Home: `/` with no query (`?tour=1` and the like asked for Home itself).
 * Read when the app's first bundle runs, so a route loaded later can't mistake a sidebar click for it. */
let fresh = window.location.pathname === '/' && !window.location.search;

/** True once, for the first protected route of a page load that opened at Home; every later navigation is the
 * user moving around the app, so Home stays reachable. */
export function takeFreshOpen(): boolean {
  const was = fresh;
  fresh = false;
  return was;
}
